//============================= DIALOGUES =============================
export const getDialogueRecords = "/admin/v1/listStories"
export const deleteDialogue = "/admin/v1/deleteStory"
export const updateDialogueStatus = "/admin/v1/updateDialog"
export const createDialogue = "/admin/v1/bootstrapStory"
export const trainDialogues = "/admin/v1/initiateDmsTraining"
//============================= EDIT DIALOGUE  =============================
// export const getDialogueDetails = "/admin/v1/getStoryData"
// export const deleteDialogueBlock = "/admin/v1/deleteDialogueBlock"
